"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _helpers = require("../../../../helpers");
var _GridView = require("../GridView");
var _ImageFile = _interopRequireDefault(require("../../ImageFile"));
var _ShareButton = _interopRequireDefault(require("../ShareButton"));
var _Product = require("../../Product");
var _Video = _interopRequireDefault(require("../../Video"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// A resource item when rendered in LIST mode
var ListViewCover = /*#__PURE__*/function (_React$Component) {
  _inherits(ListViewCover, _React$Component);
  var _super = _createSuper(ListViewCover);
  function ListViewCover() {
    var _this;
    _classCallCheck(this, ListViewCover);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderCover", function (resource) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].coverImage
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: resource.small,
        alt: "resource cover"
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderThumbnail", function (resource) {
      var metadata = JSON.parse(resource.published_metadata) || {};
      var imageStyle = metadata.imageStyle || 'cover';
      if (resource.type === 'video' || (0, _GridView.isResourceImage)(resource)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-3",
          style: {
            backgroundImage: "url(".concat(resource.small, ")"),
            backgroundPosition: imageStyle === 'icon' ? '100% 3.7em' : 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: imageStyle === 'icon' ? '75px 75px' : imageStyle
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("a", _extends({
            href: "#"
          }, (0, _GridView.addViewResourceEventOnClick)(resource)), _this.renderCover(resource)),
          size: "large",
          title: resource.published_label
        }, resource.type === 'video' ? /*#__PURE__*/_react["default"].createElement(_Video["default"], {
          resource: resource
        }) : /*#__PURE__*/_react["default"].createElement(_ImageFile["default"], {
          resource: resource
        })));
      }
      var courseClosed = resource.type === 'course' && !resource.courseData.isOpen;
      var linkProps = resource.type !== 'course' ? {
        target: '_blank',
        rel: 'noopener noreferrer'
      } : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-3",
        style: {
          backgroundImage: "url(".concat(resource.small, ")"),
          backgroundPosition: imageStyle === 'icon' ? '100% 3.7em' : 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: imageStyle === 'icon' ? '75px 75px' : imageStyle
        }
      }, ['product'].includes(resource.type) ? _this.renderCover(resource) : /*#__PURE__*/_react["default"].createElement("a", _extends({
        href: (0, _GridView.getExternalLink)(resource),
        style: courseClosed && {
          cursor: 'not-allowed'
        } || {}
      }, linkProps, (0, _GridView.addViewResourceEventOnClick)(resource)), _this.renderCover(resource)));
    });
    return _this;
  }
  _createClass(ListViewCover, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        displayOptions = _this$props.displayOptions,
        getShareUrl = _this$props.getShareUrl,
        currentTab = _this$props.currentTab;
      return /*#__PURE__*/_react["default"].createElement("div", null, this.props.data.map(function (resource) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: 'row ' + _style["default"].item,
          style: {
            borderLeft: resource.borderColor && "10px solid ".concat((0, _helpers.getBorderColor)(resource.borderColor))
          },
          key: resource.id
        }, displayOptions.showThumbnail && _this2.renderThumbnail(resource), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_style["default"].content, " col-sm-").concat(displayOptions.showThumbnail ? '9' : '12')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].innerContent
        }, (0, _GridView.renderTitle)(resource, displayOptions), (0, _GridView.renderDescription)(resource, displayOptions)), resource.type === 'product' ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].footer
        }, /*#__PURE__*/_react["default"].createElement(_Product.ProductFooter, {
          resource: resource,
          displayOptions: displayOptions,
          externalShareUrl: getShareUrl(currentTab, resource)
        })) : /*#__PURE__*/_react["default"].createElement("div", {
          className: "row ".concat(_style["default"].footer)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-6"
        }, displayOptions.showTags && /*#__PURE__*/_react["default"].createElement("p", {
          className: _style["default"].tags
        }, resource.tags && Object.keys(resource.tags).map(function (tag, j) {
          if (Object.keys(resource.tags).length === j + 1) {
            return resource.tags[tag];
          }
          return resource.tags[tag] + ', ';
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-3"
        }, (0, _GridView.renderIcons)(resource, displayOptions)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-xs-3"
        }, displayOptions.showShareButton && /*#__PURE__*/_react["default"].createElement(_ShareButton["default"], {
          name: resource.published_label,
          url: _this2.props.getShareUrl(_this2.props.currentTab, resource),
          displayOptions: displayOptions
        })))));
      }));
    }
  }]);
  return ListViewCover;
}(_react["default"].Component);
exports["default"] = ListViewCover;
_defineProperty(ListViewCover, "propTypes", {
  currentTab: _propTypes["default"].string,
  data: _propTypes["default"].array.isRequired,
  displayOptions: _propTypes["default"].object,
  getShareUrl: _propTypes["default"].func
});